






















































import { Component } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { FivGoalGroupType, IFivGoalGroup } from 'admiral-core';
import { FivApi } from '@/services/FivApi';
import GoalsOverviewTable from '@/views/pages/fivgoals/GoalsOverviewTable.vue';
import BusinessYearFilter from '@/components/filters/BusinessYearFilter.vue';
import Multiselect from 'vue-multiselect';
import { CheckIcon } from 'vue-feather-icons';

@Component({
  name: 'agency-goals-settings',
  components: { BusinessYearFilter, GoalsOverviewTable, Multiselect, CheckIcon },
})
class AgencyGoalsSettings extends mixins(BaseMixin) {
  selectedYear: number = new Date().getFullYear();

  latestBusinessPlanGoalGroup: IFivGoalGroup | null = null;

  latestCompetitionHessClubGoalGroup: IFivGoalGroup | null = null;
  latestCompetitionRingGoalGroup: IFivGoalGroup | null = null;
  latestCompetitionFallAdsGoalGroup: IFivGoalGroup | null = null;

  async mounted() {
    await this.loadGoals();
  }

  async loadGoals() {
    const responseBusinessPlan = await FivApi.getGoalGroup({
      agency: this.agency,
      groupType: FivGoalGroupType.BusinessPlan,
      year: this.selectedYear,
    });
    this.latestBusinessPlanGoalGroup = responseBusinessPlan.data;

    const responseHessClub = await FivApi.getGoalGroup({
      agency: this.agency,
      groupType: FivGoalGroupType.Competitions,
      year: this.selectedYear,
    });
    this.latestCompetitionHessClubGoalGroup = responseHessClub.data;

    const responseRing = await FivApi.getGoalGroup({
      agency: this.agency,
      groupType: FivGoalGroupType.Competitions,
      year: this.selectedYear,
    });
    this.latestCompetitionRingGoalGroup = responseRing.data;

    const responseFallAds = await FivApi.getGoalGroup({
      agency: this.agency,
      groupType: FivGoalGroupType.Competitions,
      year: this.selectedYear,
    });
    this.latestCompetitionFallAdsGoalGroup = responseFallAds.data;
  }

  get agency() {
    return this.user.agency;
  }

  get yearOptions() {
    return [2024, 2023, 2022, 2021];
  }

  labelYear(year: number) {
    return `Geschäftsjahr ${year}`;
  }
  async changed(year: number) {
    this.selectedYear = year;
    await this.loadGoals();
  }
}

export default AgencyGoalsSettings;
